import Vue from 'vue'
import VueRouter from 'vue-router'
//index页面默认只找上一层即可
import redirect from '@/views/rms86/redirect'
import main from '@/views/rms86/main.vue'
import login from '@/views/rms86/login'
import login_error from '@/views/rms86/login/login_error'
import tutorialView from '@/views/rms86/JobTutorial/JobTutorial_view'
import ai_scan_pic from '@/views/rms86/ai_scan_pic/Index.vue'

Vue.use(VueRouter);
// 1. 创建路由组件
// 2. 将路由与组件进行映射
// 3. 创建router实例
const routes = [
  // 主路由
  {
    path: '/',
    name: 'main',
    component: main,
    redirect: '/home',// 重定向(首页默认为home)
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/login_error',
    name: 'login_error',
    component: login_error
  },
  {
    path: '/redirect',
    name: 'redirect',
    component: main,
  /*   meta: {
      istrun: true // 默认隐藏路由
    }, */
    children: [
      {
        path: '/redirect/:path(.*)',
         component: () => import('@/views/rms86/redirect')
      }
    ] 
  },
  {
    path: '/JobTutorial_view',
    name: 'JobTutorial_view',
    component: tutorialView,
    meta: {
      istrun: true // 默认隐藏路由
    },
  },
  {
    path: '/ai_scan_pic',
    name: 'ai_scan_pic',
    component: ai_scan_pic,
    meta: {
      istrun: true // 默认隐藏路由
    },
  },
]

const router = new VueRouter({
  //mode: 'history', // 去掉url中的#
  mode: 'hash',
  routes // 公共路由
})

//重复点击导航时防止页面丢失
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router


